import React, { useEffect, useState } from "react";
import { getMyProfile, updateMyProfile } from "../services/EmployeeService";
import EmployeeNavbar from "../components/EmployeeNavbar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCamera, faPen } from "@fortawesome/free-solid-svg-icons";

const EmployeeProfile = () => {
  const [employee, setEmployee] = useState({});
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    const fetchProfile = async () => {
      const data = await getMyProfile();
      setEmployee(data);
    };
    fetchProfile();
  }, []);

  const handleChange = (e) => {
    setEmployee({ ...employee, [e.target.name]: e.target.value });
  };

  const handleUpdate = async () => {
    const updated = await updateMyProfile(employee);
    localStorage.setItem("employee", JSON.stringify(updated));
    setIsEditing(false);
  };

  return (
    <>
      <EmployeeNavbar />
      <div style={{ marginTop: "4rem" }}></div>
      <div className="container profile-card shadow p-4 bg-white rounded">
        <div className="d-flex justify-content-between align-items-start">
          <div className="d-flex align-items-center">
            <div className="profile-avatar position-relative me-4">
              <img
                src="/img/default-avatar.png"
                alt="avatar"
                className="rounded-circle"
                width="100"
                height="100"
              />
              <div className="camera-icon">
                <FontAwesomeIcon icon={faCamera} />
              </div>
            </div>
            <div>
              <h3>
                {isEditing ? (
                    <>
                    <input
                        type="text"
                        name="firstName"
                        value={employee.firstName || ""}
                        onChange={handleChange}
                        className="form-control mb-2"
                        placeholder="First Name"
                        style={{ maxWidth: "300px" }}
                    />
                    <input
                        type="text"
                        name="lastName"
                        value={employee.lastName || ""}
                        onChange={handleChange}
                        className="form-control"
                        placeholder="Last Name"
                        style={{ maxWidth: "300px" }}
                    />
                    </>
                ) : (
                    `${employee.firstName} ${employee.lastName}`
                )}
                </h3>
              <p><strong>Account Type:</strong> Primary Account</p>
              <p><strong>Username:</strong> {employee.username}</p>
              <p><strong>Email:</strong>{" "}
                {isEditing ? (
                  <input
                    type="email"
                    name="email"
                    value={employee.email || ""}
                    onChange={handleChange}
                    className="form-control"
                  />
                ) : (
                  employee.email
                )}
              </p>
              <p><strong>Date of birth:</strong> {employee.dob || "N/A"}</p>
            </div>
          </div>
          <div>
            {isEditing ? (
              <button className="btn btn-success" onClick={handleUpdate}>
                Save
              </button>
            ) : (
              <button className="btn btn-outline-primary" onClick={() => setIsEditing(true)}>
                Edit <FontAwesomeIcon icon={faPen} className="ms-2" />
              </button>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default EmployeeProfile;
